import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import type { MaintenanceSettings } from '@/models'

interface GetMaintenanceSettingsRequest {
  buildingId: number
}

export const MAINTENANCE_SETTINGS_BASE_QUERY_KEY = 'useGetMaintenanceSettings'

export const getMaintenanceSettingsQueryKey = (data: GetMaintenanceSettingsRequest) => [
  MAINTENANCE_SETTINGS_BASE_QUERY_KEY,
  data,
]

export const getMaintenanceSettings = async (
  params: GetMaintenanceSettingsRequest,
): Promise<MaintenanceSettings> => {
  const response = await authAPI.get<MaintenanceSettings>('/v2/maintenance/settings', { params })
  return response.data
}

export const useGetMaintenanceSettings = (data: GetMaintenanceSettingsRequest) => {
  return useQuery({
    enabled: data.buildingId > 0,
    queryFn: () => getMaintenanceSettings(data),
    queryKey: getMaintenanceSettingsQueryKey(data),
  })
}
